import styles from "./MessageBubble.styles.scss";
import Icon from "../Icon/Icon";
import Menu from "../../containers/Menu/Menu";
import MessageBubbleContent from "../MessageBubbleContent/MessageBubbleContent";

const MessageBubble = ({
  message,
  timestamp,
  senderName,
  senderColor,
  readBy = 1,
  isAppended = false,
  isOwner = false,
  isHovering = false,
  isMenuVisible = false,
  onMouseEnter,
  onMouseLeave,
  options,
  onClickOutsideMenu,
  onToggleMenu,
  isModerator,
  hiddenByModerator,
  isSilenced = false,
}) => {
  return <div
    className={`${styles.container} ${isOwner &&
      styles.containerOwner} ${isAppended && styles.containerAppended}`}
  >
    {!isAppended && !isOwner && <div className={styles.tailContainer} />}
    <div className={`${styles.wrapper} ${isOwner && styles.wrapperOwner}`} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {(isHovering || isMenuVisible) && !isOwner && isModerator && options.length > 0 && <Menu
        isVisible={isMenuVisible}
        options={options}
        onClickOutside={onClickOutsideMenu}
        onClick={onToggleMenu}
        tippyOpts={{placement: 'bottom-end', offset: [0, 20]}}>
        <div className={[styles.options].join(" ")}><Icon name="chevron_down" /></div>
      </Menu>}
      {senderName && !isAppended && <div className={styles.senderName} style={{color: senderColor}}>
        <div>{senderName}</div>
        {isSilenced && <Icon className={styles.senderNameIcon} size={12.8} name="volume_off" />}
      </div>}
      <MessageBubbleContent message={message} />
      {!hiddenByModerator && <div className={styles.timestamp}>
        <span>{timestamp}</span>
        {readBy !== 2 && <Icon name="check" color="#9E9E9E" size={14} className={styles.timestampIcon} />}
        {readBy === 2 && <Icon name="check_all" color="#00AFFF" size={14} className={styles.timestampIcon} />}
      </div>}
    </div>
    {!isAppended && isOwner && <div className={styles.tailContainerOwner} />}
  </div>
};

export default MessageBubble;



// WEBPACK FOOTER //
// ./components/MessageBubble/MessageBubble.js